import React from 'react';

import { createStyles } from "./styles";

var QuestionEntity = function QuestionEntity(props) {
  var label = props.label,disclaimer = props.disclaimer,children = props.children;
  var classes = createStyles(props);

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.question },
    (label === null || label === void 0 ? void 0 : label.length) > 0 && /*#__PURE__*/
    React.createElement("div", { className: classes.descriptionBlock }, /*#__PURE__*/
    React.createElement("h3", { className: classes.title, dangerouslySetInnerHTML: { __html: label } }),
    disclaimer && /*#__PURE__*/React.createElement("h4", { className: classes.disclaimer }, disclaimer)), /*#__PURE__*/


    React.createElement("div", { className: classes.contentWrapper }, children)));


};

export default QuestionEntity;
//# sourceMappingURL=index.js.map